import {
  getMonitoringInfos,
  getAllProjects,
  getProjectTime,
  getProjectRemainingTime,
  getProjectMonthMonitoring,
  getProjectContract,
  getProjectPrice,
  createProjectContract,
  updateProjectContract,
  saveData
} from '../api/monitorings.js';

export default {
  state: {
    monitoring: [],
    projectsList: [],
    projectMonth: [],
    projectTime: [],
    contracts: [],
    projectPrice: [],
    remainingTime: [],
    newEntity: null
  },
  mutations: {
    getMonitoring(state, monitoring) {
      state.monitoring = monitoring;
    },
    getProjectsList(state, projectsList) {
      state.projectsList = projectsList;
    },
    getProjectRemainingTime(state, remainingTime) {
      state.remainingTime = remainingTime;
    },
    getProjectTime(state, projectTime) {
      state.projectTime = projectTime;
    },
    getProjectMonthMonitoring(state, projectMonth) {
      state.projectMonth = projectMonth;
    },
    getProjectContract(state, contracts) {
      state.contracts = contracts;
    },
    getProjectPrice(state, projectPrice) {
      state.projectPrice = projectPrice;
    },
    createProjectContract(state, project) {
      state.newEntity = project;
    },
    updateProjectContract(state, project) {
      state.newEntity = project;
    },
    saveData(state, data) {
      state.newEntity = data;
    }
  },
  actions: {
    async getMonitoring({ commit }, id) {
      const response = await getMonitoringInfos(id);
      commit("getMonitoring", response);
    },
    async getAllProjects({ commit }) {
      const response = await getAllProjects();
      commit("getProjectsList", response);
    },
    async getProjectTime({ commit }, id) {
      const response = await getProjectTime(id);
      commit("getProjectTime", response);
    },
    async getProjectRemainingTime({ commit }, id) {
      const response = await getProjectRemainingTime(id);
      response.forEach(e =>
        e.name = (([firstName, ...rest]) => [firstName, rest.join(" ").toUpperCase()].join(" "))(e.name.split(" "))
      );
      commit("getProjectRemainingTime", response);
    },
    async getProjectMonthMonitoring({ commit }, id) {
      const response = await getProjectMonthMonitoring(id);
      response.forEach(e =>
        e.username = (([firstName, ...rest]) => [firstName, rest.join(" ").toUpperCase()].join(" "))(e.username.split(" "))
      );
      commit("getProjectMonthMonitoring", response);
    },
    async getProjectContract({ commit }) {
      const response = await getProjectContract();
      commit("getProjectContract", response);
    },
    async getProjectPrice({ commit }, id) {
      const response = await getProjectPrice(id);
      commit("getProjectPrice", response);
    },
    async createProjectContract({ commit, dispatch }, data) {
      try {
        const response = await createProjectContract(data);
        commit("createProjectContract", response);
        return response;
      } catch (error) {
        switch (error.message.name) {
          case "missingFields":
            dispatch("setToastMessage", {
              message: `Missing fields : \n${error.message.message}`
            });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
            break;
          case "SequelizeUniqueConstraintError":
            dispatch("setToastMessage", {
              message: `Le projet existe déjà`
            });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
            break;
          default:
            dispatch("setToastMessage", { message: "errorOccured" });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
            return;
        }
      }
    },
    async updateProjectContract({ commit, dispatch }, data) {
      try {
        const response = await updateProjectContract(data);
        commit("updateProjectContract", response);
        return response;
      } catch (error) {
        switch (error.message.name) {
          case "missingFields":
            dispatch("setToastMessage", {
              message: `Missing fields : \n${error.message.message}`
            });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
            break;
          default:
            dispatch("setToastMessage", { message: "errorOccured" });
            dispatch("setToastMode", { mode: "error" });
            dispatch("setOpenToast", { opened: true });
            return;
        }
      }
    },
    async saveData({ commit, dispatch }, data) {
      try {
        const response = await saveData(data);
        commit("saveData", response);
        return response;
      } catch (error) {
        dispatch("setToastMessage", { message: `Des projets n'ont pas pu être enregistrés (id: ${error.message})` });
        dispatch("setToastMode", { mode: "error" });
        dispatch("setOpenToast", { opened: true });
        return;
      }
    },
  }
}